import request from '@/utils/analyticsRequest'

export function getGhlAiSettings() {
  return request({ url: '/api/v1/ghl/ai/settings', method: 'get' })
}

export function updateGhlAiSettings(data) {
  return request({
    url: '/api/v1/ghl/ai/settings',
    method: 'put',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function resumeGhlAiConversation(data) {
  return request({ url: '/api/v1/ghl/ai/settings/resume', method: 'post', data })
}

export function getGhlAiUsage(period = 'rolling_30d') {
  return request({
    url: '/api/v1/ghl/ai/usage',
    method: 'get',
    params: { period }
  })
}

export function suggestSocialCaption(data) {
  return request({
    url: '/api/v1/ghl/ai/social-captions',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
    timeout: 35000
  })
}

export function suggestSocialImage(formData) {
  return request({
    url: '/api/v1/ghl/ai/social-images',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 180000
  })
}

export function formatAiCostUsd(amount) {
  const value = Number(amount) || 0
  if (value === 0) return '$0.00'
  if (value < 0.01) return `$${value.toFixed(4)}`
  return `$${value.toFixed(3)}`
}
